import { Col, Divider, Drawer, Row, Space } from 'antd';
import { useMapboxContext } from '../mapbox/context/mapbox-context';
import SwitchLayer from './switch-layer';
import SelectStyle from './select-style';


const DrawerSettings = () => {
const { isOpenSettings, styleLayers, setMenuSettings} = useMapboxContext();

const onClose = () => {
  setMenuSettings(!isOpenSettings);
}

const showSwitchLayers = () => {
    const switchLayers = styleLayers.map((layer) => (
      <div key={`${layer.layerId}`} style={{padding:"5px"}}>
        <Row gutter={[16, 16]}>
          <Col span={20}>
            <div>{layer.layerId}</div>
          </Col>
          <Col span={4}>
            <SwitchLayer layerId={layer.layerId} visible={layer.visible} />
          </Col>
        </Row>
      </div>
    ));
  
    return switchLayers;
  };
  
  

  return (
   
   <Drawer onClose={onClose} open={isOpenSettings} width={"30%"} title={<div style={{color:"white"}}>Settings</div>} style={{backgroundColor:"black", color:"white"}}>
     <Divider orientation="left" style={{color:"white", borderColor:"white"}}>Style</Divider>
    <SelectStyle />
    <Divider orientation="left" style={{color:"white", borderColor:"white"}}>Layers</Divider>
    {showSwitchLayers()}

   </Drawer>
  );
}

export default DrawerSettings;
